export const defaultGuid = '2b77c674e55b4696a0127c47fe592596';
export const defaultToken = '8438d41f20b448fe92461e794f23a5ed';

export const defaultHashMap = [
  [6, 18, 29, 3, 15, 24],
  [11, 7, 20, 1, 27, 14],
  [23, 5, 9, 30, 16, 2],
  [8, 25, 0, 21, 12, 19],
  [28, 4, 10, 13, 22, 17],
  [31, 26, 15, 6, 9, 20],
  [14, 3, 7, 18, 30, 1],
  [2, 12, 23, 8, 25, 27],
];

export const defaultRule = [1, 3, 7];

export const userHashMap = [
  [15, 2, 30, 7, 21, 10],
  [28, 1, 17, 23, 12, 5],
  [9, 19, 6, 31, 14, 25],
  [3, 27, 20, 16, 0, 11],
  [8, 29, 13, 22, 18, 4],
  [24, 26, 30, 1, 7, 9],
  [5, 12, 28, 2, 31, 15],
  [10, 20, 6, 27, 23, 14],
];

export const userRule = [2, 5, 6];

export const commonAPI = ['/api/sys/login'];
